import { render, staticRenderFns } from "./ViewSupport.vue?vue&type=template&id=4e0a6498&scoped=true&"
import script from "./ViewSupport.vue?vue&type=script&lang=js&"
export * from "./ViewSupport.vue?vue&type=script&lang=js&"
import style0 from "./ViewSupport.vue?vue&type=style&index=0&id=4e0a6498&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0a6498",
  null
  
)

export default component.exports